import React, { useState } from "react"
import { LibraryBooks, Group, BusinessOutlined } from '@mui/icons-material'
import { Divider, Tabs, Tab, Container } from '@mui/material'
import ManageUsers from './ManageUsers'
import ManageDatasets from "./ManageDatasets"
import ManageRanking from "./ManageRanking"
import ManageCompany from "./ManageCopany"
import styles from './index.module.css'

const TabPanel = ({ children, value, activeTab}) => 
  value === activeTab
    ? <div role="tabpanel" className={styles['panel']}>{children}</div>
    : <></>

export default function Settings() {
  const [activeTab, setActiveTab] = useState('users')

  const handleChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const adminTabs = [
    <Tab label="Manage Users" value="users" icon={<Group/>} key="users" />,
    <Tab label="Manage Datasets" value="datasets" icon={<LibraryBooks />} key="datasets" />,
    <Tab label="Manage Ranking" value="ranking" icon={<LibraryBooks />} key="ranking" />,
    <Tab label="Manage Company" value="company" icon={<BusinessOutlined />} key="company" />
  ]
 

  const adminTabsPanel = [
    <TabPanel value="users" activeTab={activeTab} key="users">
      <ManageUsers/>
    </TabPanel>,
    <TabPanel value="datasets" activeTab={activeTab} key="datasets">
      <ManageDatasets/>
    </TabPanel>,
    <TabPanel value="ranking" activeTab={activeTab} key="ranking">
      <ManageRanking/>
    </TabPanel>,
    <TabPanel value="company" activeTab={activeTab} key="company">
      <ManageCompany/>
    </TabPanel>,
  ]

  return (
    <>
      <Container maxWidth="lg">
        <Tabs value={activeTab} onChange={handleChange}>
          {adminTabs}
        </Tabs>
      </Container>
      <Divider/>
      <Container maxWidth="lg">
        {adminTabsPanel}
      </Container>
    </>
  )
}
